const WasteManagementAdminMenu = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_2312_11288)"
      fill-opacity="0.1"
    />
    <g clip-path="url(#clip0_2312_11288)">
      <path
        d="M23.0551 17.66L22.2251 17.1758C21.326 16.6225 21.326 15.3083 22.2251 14.755L23.0551 14.2708C23.7468 13.8558 23.9543 13.0258 23.5393 12.4033L22.8476 11.2275C22.4326 10.5358 21.6026 10.3283 20.9801 10.7433L20.1501 11.2275C19.251 11.7808 18.0751 11.0891 18.0751 10.0516V9.08328C18.0751 8.32245 17.4526 7.69995 16.6918 7.69995H15.3085C14.5476 7.69995 13.9251 8.32245 13.9251 9.08328V9.98245C13.9251 11.02 12.7493 11.7116 11.8501 11.1583L11.0201 10.7433C10.3285 10.3283 9.49848 10.605 9.15264 11.2275L8.46098 12.4033C8.11514 13.095 8.32264 13.925 8.94514 14.34L9.77514 14.8241C10.6743 15.3083 10.6743 16.6916 9.77514 17.1758L8.94514 17.66C8.25348 18.075 8.04598 18.905 8.46098 19.5275L9.15264 20.7033C9.56764 21.395 10.3976 21.6025 11.0201 21.1875L11.8501 20.7725C12.7493 20.2191 13.9251 20.9108 13.9251 21.9483V22.9166C13.9251 23.6775 14.5476 24.3 15.3085 24.3H16.6918C17.4526 24.3 18.0751 23.6775 18.0751 22.9166V22.0175C18.0751 20.98 19.251 20.2883 20.1501 20.8416L20.9801 21.3258C21.6718 21.7408 22.5018 21.4641 22.8476 20.8416L23.5393 19.6658C23.8851 18.905 23.6776 18.075 23.0551 17.66ZM16.0001 18.7666C14.4785 18.7666 13.2335 17.5216 13.2335 16C13.2335 14.4783 14.4785 13.2333 16.0001 13.2333C17.5218 13.2333 18.7668 14.4783 18.7668 16C18.7668 17.5216 17.5218 18.7666 16.0001 18.7666Z"
        fill="#052351"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2312_11288"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0062FF" />
        <stop offset="1" stop-color="#004BC2" />
      </linearGradient>
      <clipPath id="clip0_2312_11288">
        <rect width="16.6" height="16.6" fill="white" transform="translate(7.7002 7.69995)" />
      </clipPath>
    </defs>
  </svg>
)

export default WasteManagementAdminMenu
